/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Line, Path, Polygon } from 'react-native-svg';

import { IconProps } from '../lib';

function Student(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Line
        x1={32}
        y1={64}
        x2={32}
        y2={144}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Path
        d="M54.23194,215.99924a88.02249,88.02249,0,0,1,147.53587-.00038"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Polygon
        points="224 64 128 96 32 64 128 32 224 64"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Path
        d="M169.33686,82.22033a56,56,0,1,1-82.67374,0"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
    </Svg>
  );
}

export default Student;
